<template>
  <div class="t-page_articles-detail t-work-area">
    <h1 class="_padding">
      {{ pageText.title }}
      <router-link :to="{name: 'articles'}">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 4H13M1 4L5 1M1 4L5 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ pageText.back }}
      </router-link>
    </h1>
    <div class="t-article-detail">
      <div class="t-article-detail__header">
        <h2 class="t-article-detail__title">{{ article.title }}</h2>
        <p class="t-article-detail__date">{{ article.date }}</p>
        <p class="t-article-detail__tags">{{ article.tags }}</p>
      </div>
      <div class="t-article-detail_text t-default" v-html="article.text"></div>
    </div>
    <div class="t-article-more">
      <router-link class="t-article-more-item" v-if="articlesMore.prev" :to="{name: 'articles_view', params: {id: articlesMore.prev.id, slug: articlesMore.prev.slug}}">
        <span>
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4.53796H13M1 4.53796L5 1M1 4.53796L5 8.07593" stroke="#84C1F6" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ pageText.prev }}
        </span>
        <p class="t-article-more-item__title">{{ articlesMore.prev.title }}</p>
        <p class="t-article-more-item__date">{{ articlesMore.prev.date }}</p>
      </router-link>
      <router-link class="t-article-more-item" v-if="articlesMore.next" :to="{name: 'articles_view', params: {id: articlesMore.next.id, slug: articlesMore.next.slug}}">
        <span>
          {{ pageText.next }}
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 4.53796H1M13 4.53796L9 1M13 4.53796L9 8.07593" stroke="#84C1F6" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <p class="t-article-more-item__title">{{ articlesMore.next.title }}</p>
        <p class="t-article-more-item__date">{{ articlesMore.next.date }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/articlesDetailPage.json' : 'staticText',
        main: {
            title: "Статьи",
            back: "К списку статей",
            next: "Следующая статья",
            prev: "Предыдущая статья"
        }
    };

    import {mapGetters, mapActions} from 'vuex';

    import Vue from 'vue'
    import {store} from '../../store'

    export default {
        data(){
            return {
                pageText: {},

                article: '',
                articlesMore: {}
            }
        },
        computed: {
            ...mapGetters(['mobileState'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText, article, articlesMore){
                this.article = article;
                this.pageText = pageText;
                this.articlesMore = articlesMore;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate (to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'articles/articleDetail.json' : 'articles/' + to.params.id;
            let url_more = process.env.NODE_ENV !== 'production' ? 'articles/articlesMore.json' : 'articles/' + to.params.id + '/more';

            let count = 0;

            let article = {},
                articlesMore = {};

            Vue.http.get(url)
                .then(response => response.json())
                .then(data => {
                    article = data;

                    count++;
                    RunNext();
                });

            Vue.http.get(url_more)
                .then(response => response.json())
                .then(data => {
                    articlesMore = data;

                    count++;
                    RunNext();
                });

            let RunNext = () => {
                if(count > 1)
                    next(this.Load(this.pageText, article, articlesMore))
            }
        },
        beforeRouteEnter (to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'articles/articleDetail.json' : 'articles/' + to.params.id;
            let url_more = process.env.NODE_ENV !== 'production' ? 'articles/articlesMore.json' : 'articles/' + to.params.id + '/more';
            let count = 0;

            let pageText = {},
                article = {},
                articlesMore = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

            Vue.http.get(url)
                .then(response => response.json())
                .then(data => {
                    article = data;

                    count++;
                    RunNext();
                });

            Vue.http.get(url_more)
                .then(response => response.json())
                .then(data => {
                    articlesMore = data;

                    count++;
                    RunNext();
                });

            let RunNext = () => {
                if(count > 2)
                    next(vm => vm.Load(pageText, article, articlesMore))
            }
        }
    }
</script>

<style lang="sass">
.t-article-detail
  max-width: 1266px
  margin: 0 auto 42px
  @extend %substrate
  padding: 40px 40px 40px 63px
  line-height: 1.2
  &__header
    border-bottom: 1px solid $input
    padding-bottom: 16px
    margin-bottom: 16px
  &__title
    margin-bottom: 8px
    font-size: 22px
    position: relative
    //margin-left: -22px
    //&:before
      content: '— '
  &__date
    font-size: 14px
    margin-bottom: 4px
  &__tags
    font-size: 14px
    font-weight: bold

.t-article-more
  display: flex
  align-items: stretch
  width: 1200px
  max-width: 100%
  margin: 0 auto
  &-item
    line-height: 1.2
    width: 50%
    span
      display: flex
      align-items: center
      font-size: 14px
      margin-bottom: 6px
      color: $border
    &__title
      font-size: 20px
      color: $blue
      font-weight: bold
      margin-bottom: 12px
    &__date
      font-size: 14px
    &:first-child
      border-right: 1px solid $input
      padding-right: 42px
      span
        svg
          margin-right: 8px
    &:last-child
      padding-left: 42px
      span
        svg
          margin-left: 8px

@media (max-width: 769px)
  .t-article-more
    flex-direction: column
  .t-article-more-item
    width: calc(100% - 32px)
    margin: 0 16px
    &:first-child
      padding-right: 0
      padding-top: 24px
      border-right: none
    &:last-child
      padding-left: 0
      padding-bottom: 24px
      border-bottom: 1px solid $input
      order: -1
</style>


// WEBPACK FOOTER //
// src/vue_pages/Articles/View.vue